module.exports = __webpack_public_path__ + "static/img/8.5fe0cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangji/8.png
// module id = vI9/
// module chunks = 1